import { EmailVerificationPendingForm } from "./EmailVerificationPendingForm";

export const EmailVerificationPendingPage = () => {
  return <EmailVerificationPendingForm />;
};
